import React from 'react';
import PropTypes from 'prop-types';
import CmsContent from '../../CmsContent';
import Block from '../../../block/Block';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import styles from './HtmlBlock.less';
export var HtmlBlock = function HtmlBlock(_ref) {
  var html = _ref.data.component.content.html;
  return html ? /*#__PURE__*/React.createElement(Block, {
    className: getClasses({
      styles: styles,
      classes: ['container']
    })
  }, /*#__PURE__*/React.createElement(CmsContent, {
    content: html
  })) : null;
};
HtmlBlock.propTypes = {
  data: PropTypes.object.isRequired
};
export default HtmlBlock;